"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alanno": {
    "4b54b3cd": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "skipSearch": false
    }],
    "candelora": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "966a3cf5": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "skipSearch": false
    }],
    "coccialonga": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a6f1e76": [{
      "hkey": "92addaa2",
      "slug": "oratorio",
      "name": "Oratorio",
      "primary": true,
      "skipSearch": false
    }],
    "oratorio-ticchione": [{
      "hkey": "92addaa2",
      "slug": "oratorio",
      "name": "Oratorio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "94426da9": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "skipSearch": false
    }],
    "ragnitelli": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "141154ff": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "skipSearch": false
    }],
    "tavernola": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79cdb9cd": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "skipSearch": false
    }],
    "villa-aurora": [{
      "hkey": "33772f9a",
      "slug": "alanno",
      "name": "Alanno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;